import { makeStyles, MessageBar, MessageBarBody, MessageBarTitle, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import MarkdownPresenter from './MarkdownPresenter';

interface GptMessageBarProps {
    title: string;
    text: string;
}
  
const styles = makeStyles({
    description: {
        maxWidth: '800px'
    },
    messageBody: {
        display: 'flex',
        flexDirection: 'row',
        ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalM, tokens.spacingVerticalM, 0),
        ...shorthands.gap('10px')
    },
    messageTitle: {
        alignContent: 'center'
    }
});

const GptMessageBar: FC<GptMessageBarProps> = ({ title, text }) => {

    const classes = styles();
    return (
        <MessageBar key={'info'} intent='info'>
            <MessageBarBody className={classes.messageBody}>
                <MessageBarTitle className={classes.messageTitle}>{title}</MessageBarTitle>
                <MarkdownPresenter text={text} />
            </MessageBarBody>
        </MessageBar>
    );
};

export default GptMessageBar;

